import { Theme } from '@mui/material';


const Chip = (theme: Theme) => {
  return {
    MuiChip: {
      variants: [
        {
          props: { color: 'default' },
          style: {
            backgroundColor: '#999',
          },
        },
      ],
    },
  };
};

export default Chip;
